import { useFormContext } from "react-hook-form";

import { MultiSelectQuestion } from "../components/MultiSelectQuestion";
import { SurveyStepLayout } from "../components/SurveyStepLayout";
import { type ScreeningSurveyFormData } from "../lib/screeningSurveySchema";
import { type EmrSystem, emrSystemLabels } from "../lib/screeningSurveyTypes";

const options = Object.entries(emrSystemLabels).map(([value, label]) => ({
  value: value as EmrSystem,
  label,
}));

interface EmrSystemsStepProps {
  onContinue: () => void;
  onBack: () => void;
  currentStep: number;
  totalSteps: number;
}

export function EmrSystemsStep(props: EmrSystemsStepProps) {
  const { onContinue, onBack, currentStep, totalSteps } = props;
  const { watch, setValue } = useFormContext<ScreeningSurveyFormData>();
  const value = watch("emrSystems") ?? [];

  return (
    <SurveyStepLayout
      currentStep={currentStep}
      totalSteps={totalSteps}
      title="Which EMR systems have you used multiple times?"
      subtitle="Select all that apply."
      continueDisabled={value.length === 0}
      onBack={onBack}
      onContinue={onContinue}
    >
      <MultiSelectQuestion
        options={options}
        selectedValues={value}
        onChange={(v) => {
          setValue("emrSystems", v);
        }}
      />
    </SurveyStepLayout>
  );
}
